module.exports = __webpack_public_path__ + "media/application/images/svgs/demsoc/icons/facebook-66b523aaf7ab67f63442e802874c6f19.svg";